/* eslint-disable @next/next/no-img-element */
import moment from "moment";
import PropTypes from "prop-types";
import { PureComponent } from "react";
import QRCode from "react-qr-code";
import {
  Body,
  Brand,
  Container,
  ContentQRCode,
  Footer,
  Header,
} from "./styles";

class Certificate extends PureComponent {
  render() {
    const { data, intl: t, locale } = this.props;
    const uuid = data?.attrs?.uuid;
    const userName = data?.attrs?.user_name;
    const courseTitle = data?.attrs?.course_title;
    const durationTime = data?.attrs?.duration_time;
    const validityDate = data?.attrs?.validity_date;
    const conclusionDate = data?.attrs?.conclusion_date;

    const themeLogoHorizontal = data?.attrs?.tenant_settings?.filter(
      (item) => item.key === "theme_logo_horizontal",
    )[0].value;

    const themeMasterColor = data?.attrs?.tenant_settings?.filter(
      (item) => item.key === "theme_master_color",
    )[0].value;

    return (
      <Container
        themeMasterColor={themeMasterColor}
        courseTitleLength={courseTitle?.length}
      >
        <Brand>
          <img src={themeLogoHorizontal} alt="logo" />
        </Brand>

        <Header
          length={courseTitle?.length}
          themeMasterColor={themeMasterColor}
        >
          <h1>{t("common:conclusionCertificate")}</h1>
          <p>{courseTitle}</p>
        </Header>

        <Body>
          <h1>{t("common:certifyThat")}</h1>
          <p>{userName}</p>
          <span>
            {t("common:completedCourseIn")}
            {moment(conclusionDate).locale(locale).format("LL")}{" "}
            {t("common:lastingFor")}
            {durationTime || 0} {t("common:hours")}.
          </span>
        </Body>

        <Footer>
          {data?.attrs?.signatures.map((item) => (
            <div key={item.key}>
              <img
                alt="Signature"
                className="signature-image"
                src={item?.attributes?.signature_image}
              />

              <p>{item?.attributes?.signature_name}</p>
              <span>{item?.attributes?.signature_title}</span>
            </div>
          ))}

          <ContentQRCode>
            <QRCode
              size={100}
              fgColor="#898692"
              value={`${location.hostname}/certificate/${uuid}`}
            />
            <p className="header-content">{t("common:checkCertification")}</p>
            <p>{`${location.hostname}/certificate/${uuid}`}</p>
            <small>
              {t("common:certificateIssuedIn")}
              {moment(conclusionDate)
                .locale(locale)
                .format("MMMM [de] YYYY")}{" "}
              {t("common:validUntil")}
              {moment(validityDate || 0)
                .locale(locale)
                .format("MMMM [de] YYYY")}
            </small>
          </ContentQRCode>
        </Footer>
      </Container>
    );
  }
}

Certificate.propTypes = {
  data: PropTypes.any.isRequired,
};

export default Certificate;
